/**
 * Shape of a Harmonic snapshot stored in record_sources.context — identical to
 * what the backend enrichment cron writes, so cron-written and frontend-written
 * snapshots are indistinguishable to readers.
 */
export type HarmonicContext<T = unknown> = {
  source: "harmonic"
  fetched_at: string
  payload: T
}

/** Wrap a raw Harmonic payload in the canonical context snapshot shape. */
export function buildHarmonicContext<T>(payload: T, now?: string): HarmonicContext<T> {
  return {
    source: "harmonic",
    fetched_at: now ?? new Date().toISOString(),
    payload,
  }
}
